export const countries = [
  { id: 'HU', text: 'Magyarország' },
  { id: 'AT', text: 'Ausztria' },
  { id: 'DE', text: 'Németország' },
  { id: 'DK', text: 'Dánia' },
  { id: 'GB', text: 'Egyesült Királyság' },
  { id: 'SK', text: 'Szlovákia' },
  { id: 'RO', text: 'Románia' },
  { id: 'AU', text: 'Ausztrália' },
];
